var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6925 11.0671L15.8838 6.49567C16.0387 6.3407 16.0387 6.03078 15.8838 5.87581L10.6925 1.30439C10.4601 1.07194 10.0726 1.30439 10.0726 1.61432V3.86129C-0.0774643 3.86129 1.75211e-05 14.7087 1.75211e-05 14.7087C1.75211e-05 14.7087 0.697353 8.51019 10.0726 8.51019V10.7572C10.0726 11.0671 10.4601 11.2995 10.6925 11.0671Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.b60e8cdb068a859a3d085ae10977b7f3.svg";
export { ForwardRef as ReactComponent };